import { createFileRoute } from '@tanstack/react-router';
import type { Id } from '@aeon-karaoke/cloud-convex/_generated/dataModel';
import { CreatePage } from '@/page/CreatePage';

export const Route = createFileRoute('/_app/create')({
  // Always return `track`: an omitted key keeps its raw value from the address.
  validateSearch: ({ track }): { track?: Id<'tracks'> } => ({
    track: typeof track === 'string' && track !== '' ? (track as Id<'tracks'>) : undefined,
  }),
  component: CreateRoute,
});

function CreateRoute() {
  const { track } = Route.useSearch();
  return <CreatePage trackId={track} />;
}
